import { useState } from "react";
import { CardImage } from "@/components/CardImage";

/**
 * Card thumbnail that magnifies on hover so collectors can read the art, the
 * printed card number and the stat band without opening a modal. Falls back to
 * a plain tap/click on touch devices (no hover), where onExpand is used instead.
 */
export function CardHoverZoom({
  src,
  alt,
  width,
  height,
  scale = 2.2,
  className = "",
  priority = false,
  onExpand,
}: {
  src: string;
  alt: string;
  width: number;
  height: number;
  scale?: number;
  className?: string;
  priority?: boolean;
  onExpand?: () => void;
}) {
  const [hover, setHover] = useState(false);
  return (
    <span
      className={`relative inline-block ${className}`}
      style={{ zIndex: hover ? 60 : undefined }}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
    >
      <button
        type="button"
        onClick={onExpand}
        onFocus={() => setHover(true)}
        onBlur={() => setHover(false)}
        aria-label={`Enlarge ${alt}`}
        className="block w-full cursor-zoom-in rounded-lg"
        style={{
          transform: hover ? `scale(${scale})` : "scale(1)",
          transformOrigin: "center center",
          transition: "transform 180ms ease-out",
          filter: hover ? "drop-shadow(0 12px 34px rgba(0,0,0,0.6))" : undefined,
          position: "relative",
          zIndex: hover ? 60 : 1,
        }}
      >
        <CardImage src={src} alt={alt} width={width} height={height} priority={priority} responsive className="w-full rounded-lg" />
      </button>
    </span>
  );
}
